<template>
  <div class="main" :style="'height:' + bgHeight + 'px'">
    <div class="content">
      <div class="title"></div>
      <div class="text">
        <div class="res-img">
          <img width="100%" src="../assets/images/success.png" alt="">
        </div>
        <p>感谢您的参与！</p>
        <p class="small-txt">我们将在甄选结果出来时第一时间通知您，</p>
        <p>祝您梦想成真。</p>
        <div class="button" @click="ok">完成</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bgHeight: 0
    }
  },
  methods: {
    ok: function () {
      this.$router.push({path: '/'})
    }
  },
  created() {
    this.bgHeight = window.screen.availHeight;
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
}
.title {
  width: 100%;
  height: 4.5rem;
  background: url('../assets/images/banner.jpg') no-repeat;
  background-size: cover;
  background-position: top;
  position: absolute;
  top: 0;
}
.text {
  width: 100%;
  height: 100%;
  background: url('../assets/images/watermark.png');
  background-position: top;
  background-size: contain;
  box-sizing: border-box;
  padding: 4.5rem 0.75rem 0;
}
.res-img {
  width: 1.9rem;
  margin: 1.7rem auto 0.5rem;
}
.text p {
  font-size: 0.36rem;
  color: #242323;
  line-height: 0.36rem;
  text-align: center;
  margin: 0;
}
.text .small-txt {
  font-size: 0.22rem;
  margin: 0.25rem 0;
}
.button {
  width: 5.9rem;
  height: 1.3rem;
  color: #fff;
  font-size: 0.46rem;
  text-align: center;
  line-height: 1.3rem;
  margin: 1.1rem auto 0;
  background: url('../assets/images/red-button.png') no-repeat;
  background-size: cover;
  background-position: center;
}
</style>